import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHourglass } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '@shared/components/button';

@Component({
  selector: 'app-wip-message',
  templateUrl: './wip-message.component.html',
  imports: [FontAwesomeModule, ButtonComponent],
})
export class WipMessageComponent {
  private location = inject(Location);

  faHourglass = faHourglass;

  public onGoBack(): void {
    this.location.back();
  }
}
